import { HelpCircle } from 'lucide-react'
import { Textarea } from '@/components/ui/Input'
import type { CloserLeadFormData } from '@/types'

interface NecessitiesSectionProps {
  formData: CloserLeadFormData
  onFieldChange: (field: string, value: string) => void
}

export function NecessitiesSection({ formData, onFieldChange }: NecessitiesSectionProps) {
  return (
    <div className='space-y-4'>
      <div className='flex items-center gap-2 mb-4'>
        <div className='p-1.5 rounded-lg bg-accent/10 text-accent'>
          <HelpCircle size={16} />
        </div>
        <span className='text-xs font-bold uppercase tracking-[0.15em] text-text-muted'>
          Necessidades & Contexto
        </span>
      </div>

      <Textarea
        label='Problema / Dor Principal'
        value={formData.problema}
        onChange={e => onFieldChange('problema', e.target.value)}
        placeholder='O que o lead busca resolver?'
        rows={3}
      />
      <Textarea
        label='Observações Adicionais'
        value={formData.observacoes}
        onChange={e => onFieldChange('observacoes', e.target.value)}
        placeholder='Notas estratégicas...'
        rows={3}
      />
    </div>
  )
}

export default NecessitiesSection
